
import Vue from 'vue'
import Buefy from 'buefy';
import 'buefy/dist/buefy.css';
import '@mdi/font/css/materialdesignicons.css'
import "../assets/scss/helpers.scss";
import "../assets/scss/custom.scss";
import moment from "moment";

Vue.use(Buefy, {
    iconfont: 'mdi',
    defaultDateFormatter: (date) => moment(date).format("DD/MM/YYYY")
});
